import { IKeyLabelPair, ValidationStatus } from './mfe-common.interfaces';

export interface InvestmentObjectivesGetData {
  selectedObjectives: IKeyLabelPair[];
  validationStatus: ValidationStatus;
}

export interface InvestmentObjectivesSetData {
  runValidation: boolean;
  errorText: string;
  selectedObjectives: IKeyLabelPair[];
}
